import { useNavigate as useNavigateRouterDom } from 'react-router-dom';
import useBrand from './useBrand';

const useNavigate = () => {
  const brand = useBrand();
  const navigateByRouterDom = useNavigateRouterDom();
  const navigate = (route: string | number) => {
    // Utile pour les actions de retour par exemple
    if (typeof route === 'number') {
      return navigateByRouterDom(route);
    }
    return navigateByRouterDom(
      '/' +
        brand.get() +
        `/${route}` +
        (route.split('/?').length > 1 ? '' : '/')
    );
  };

  return navigate;
};

export default useNavigate;
